export default __webpack_public_path__ + "static/media/filt.b09e1824.svg";